// extracted by mini-css-extract-plugin
export default {"component":"Card_component__6ETij","shadow":"Card_shadow__doguA","dark":"Card_dark__QLcfP"};